export const overviewTourIds = {
  overviewTab: "overview-tab-id",
  saleTab: "sale-tab-id",
  shopTab: "shop-tab-id",
  connectionTab: "connection-tab-id",
  businessSettingAnchor: "business-settings-anchor-id",
  businessSettingDropdown: "business-settings-dropdown-id",
  profileAnchor: "profile-anchor-id",
  profileDropdown: "profile-dropdown-id",
} as const;
